import { __assign, __awaiter, __generator } from "tslib";
import { replaceTraps } from './wrap-idb-value';
var readMethods = ['get', 'getKey', 'getAll', 'getAllKeys', 'count'];
var writeMethods = ['put', 'add', 'delete', 'clear'];
var cachedMethods = new Map();
function getMethod(target, prop) {
    if (!(target instanceof IDBDatabase &&
        !(prop in target) &&
        typeof prop === 'string')) {
        return;
    }
    if (cachedMethods.get(prop))
        return cachedMethods.get(prop);
    var targetFuncName = prop.replace(/FromIndex$/, '');
    var useIndex = prop !== targetFuncName;
    var isWrite = writeMethods.includes(targetFuncName);
    if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) ||
        !(isWrite || readMethods.includes(targetFuncName))) {
        return;
    }
    var method = function (storeName) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var tx, target, returnVal;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
                        target = tx.store;
                        if (useIndex)
                            target = target.index(args.shift());
                        returnVal = (_a = target)[targetFuncName].apply(_a, args);
                        if (!isWrite) return [3 /*break*/, 2];
                        return [4 /*yield*/, tx.done];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/, returnVal];
                }
            });
        });
    };
    cachedMethods.set(prop, method);
    return method;
}
replaceTraps(function (oldTraps) { return (__assign(__assign({}, oldTraps), { get: function (target, prop, receiver) {
        return getMethod(target, prop) || oldTraps.get(target, prop, receiver);
    }, has: function (target, prop) {
        return !!getMethod(target, prop) || oldTraps.has(target, prop);
    } })); });
